export default "__VITE_ASSET__DaUQbFrj__"